export default __webpack_public_path__ + "static/media/landing-bg-compressed.c9a2d434.jpg";